import { useState, useEffect, useRef } from 'react';

export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const previousScrollY = useRef<number>(0);
  const [windowHeight, setWindowHeight] = useState<number | null>(null);

  const throttle = (callback: (...args: any[]) => void, limit: number): ((...args: any[]) => void) => {
    let lastCall = 0;
    return (...args) => {
      const now = new Date().getTime();
      if (now - lastCall < limit) {
        return;
      }
      lastCall = now;
      callback(...args);
    };
  };

  const toggleVisibility = () => {
    const currentScrollY = window.scrollY;

    if (!windowHeight) return;

    if (currentScrollY < previousScrollY.current && currentScrollY <= windowHeight) {
      setIsVisible(false);
    } else if (currentScrollY > previousScrollY.current && currentScrollY > windowHeight && !isVisible) {
      setIsVisible(true);
    }

    previousScrollY.current = currentScrollY;
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    // Attach throttled scroll listener
    const throttledToggleVisibility = throttle(toggleVisibility, 200);
    window.addEventListener('scroll', throttledToggleVisibility);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', throttledToggleVisibility);
    };
  }, [windowHeight, isVisible]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <div onClick={scrollToTop} className={'back-to-top'}>
          <span className={'back-to-top__arrow'}>&uarr;</span>
        </div>
      )}
    </>
  );
}
